/**
 * @author Yaochao
 * @date 2021/7/30 14:58
 * @description
 */
import React from 'react'

const ZkSplitBar = () => {
    return (
        <div className='hSplitBar'>
            <span></span>
        </div>
    )
};

export default ZkSplitBar